declare global {
  interface Window {
    dataLayer: any[];
  }
}

import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.tsx'
import './index.css'
import './i18n'
import { initGlobalErrorReporting, reportPerformance } from './utils/telemetry'
import { initSentry } from './utils/sentry'
import { sweepAlbumCacheBase64Once } from './hooks/useAlbum'

initGlobalErrorReporting();
// 기존 사용자의 큰 album-cache 항목을 1회 정리해 quota 회복.
sweepAlbumCacheBase64Once();
// Sentry 초기화 — DSN이 설정된 환경에서만 활성화
initSentry(import.meta.env.VITE_SENTRY_DSN as string | undefined);

// Web Vitals: LCP 수집 (PerformanceObserver 기반 — getEntriesByType deprecated)
if (typeof PerformanceObserver !== 'undefined') {
  try {
    const lcpObserver = new PerformanceObserver((list) => {
      const entries = list.getEntries();
      const lcp = entries[entries.length - 1];
      if (lcp) reportPerformance('LCP', lcp.startTime);
    });
    lcpObserver.observe({ type: 'largest-contentful-paint', buffered: true });
  } catch {
    // Browser doesn't support LCP observer — silently skip
  }
}

// Google Analytics 4
const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID as string | undefined;
if (GA_MEASUREMENT_ID) {
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);
  window.dataLayer = window.dataLayer || [];
  function gtag(...args: any[]) { window.dataLayer.push(args); }
  gtag('js', new Date());
  gtag('config', GA_MEASUREMENT_ID);
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
    <App />
  </BrowserRouter>
)
